import React from "react";
import { Box, Typography } from "@mui/material";
import WaterIcon from "@mui/icons-material/Water";

const Intro = () => {
  return (
    <Box>
      <Box paddingBottom={{ xs: "1%", sm: "3%" }}>
        <Typography
          variant="h6"
          color="#9DCC49"
          fontWeight={800}
          paddingTop={"4%"}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          <Box component={"span"}>
            <WaterIcon
              sx={{
                width: 23,
                height: 23,
              }}
            />
          </Box>{" "}
          Our Key Management Staff
        </Typography>
        <Typography
          variant="h3"
          color="#317ABE"
          fontWeight={800}
          paddingBottom={"1%"}
          textAlign={"left"}
        >
          Together, let's echo the call for a sustainable blue future.
        </Typography>
      </Box>
      <Typography
        variant={"body1"}
        fontWeight={400}
        textAlign={"left"}
        color={"#000"}
        paddingBottom={"2%"}
      >
        The key management staff of Blue-Echo Foundation comprises seasoned
        professionals with extensive experience in aquaculture, fisheries
        management, and sustainable development. Leading the team is Steve
        Okeleji, the Founder and an expert in aquaculture and fisheries, who has
        spearheaded numerous initiatives to advance sustainable fish farming and
        climate change advocacy. Joining him is Edna Eligado Dionisio, the
        Technical Adviser, with over 33 years of expertise in fish genetics and
        aquaculture management, recognized for her contributions to global
        projects like the Genetic Improvement of Farmed Tilapia (GIFT).
        Together, they bring deep industry knowledge and a shared commitment to
        fostering the blue economy and environmental sustainability in emerging
        markets.
      </Typography>
    </Box>
  );
};

export default Intro;
